const ArrowLeftIcon = ({ sm = false, color = "#5B6075" }) => {
  if (sm) {
    return (
      <svg
        width="8"
        height="14"
        viewBox="52.23 32.644 52.23 91.402"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M97.93 39.173 58.758 78.344l39.173 39.173"
          stroke={color}
          strokeWidth="13.0573828125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.25 10.5L15.75 21L26.25 31.5"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowLeftIcon;
